import { jsx as _jsx } from "react/jsx-runtime";
import { LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { convertExpressionToSchemaFE } from '../../../../../schema-converion-fe/convertExpressionToSchemaFE.js';
import { BadImplementationException, deepClone } from '@nu-art/ts-common';
import { QJSONViewer } from '../../../../../../q-components/index.js';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
export class Component_PyJsonPreview extends TS_EditableItemComponent {
    deriveStateFromProps(nextProps, state) {
        return super.deriveStateFromProps(nextProps, state);
    }
    getConvertedExpression = () => {
        return convertExpressionToSchemaFE(deepClone(this.state.editable.item));
    };
    renderErrorMsg(msg) {
        return _jsx(LL_V_L, { children: _jsx("div", { style: { whiteSpace: 'break-spaces' }, children: msg }) });
    }
    render() {
        if (!this.state.editable.get('_id'))
            return _jsx(LL_V_L, { children: _jsx("div", { style: { whiteSpace: 'break-spaces' }, children: "Save expression in order to see py json preview..." }) });
        let editableClone;
        try {
            editableClone = this.getConvertedExpression();
            if (!editableClone)
                return this.renderErrorMsg(`Couldn't render expression, some features not implemented yet`);
        }
        catch (err) {
            if (err instanceof BadImplementationException) {
                return this.renderErrorMsg(`Couldn't render expression:\n${err.message}`);
            }
            else
                throw err;
        }
        return _jsx(LL_V_L, { className: 'json-view', children: _jsx(QJSONViewer, { item: editableClone }) });
    }
}
//# sourceMappingURL=Component_PyJsonPreview.js.map